import { useMemo } from 'react';
import { isEmpty, isObject } from 'lodash/fp';

export const useFilteredList = (list, filterValue, filterBy = null) =>
    useMemo(
        () =>
            isEmpty(filterValue)
                ? list
                : list.filter((entry) =>
                      isObject(entry)
                          ? entry[filterBy].toLowerCase().includes(filterValue.toLowerCase())
                          : entry.toLowerCase().includes(filterValue.toLowerCase())
                  ),
        [list, filterBy, filterValue]
    );
